import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const ProtectedRoute = ({ children, adminOnly = false, superAdminOnly = false, moduleAccess = null, moduleAccessAny = null, kadryHROnly = false }) => {
  const { user } = useAuth();

  // Jeśli wymagane są uprawnienia super admina
  if (superAdminOnly && user?.role !== 'super admin') {
    return <Navigate to="/profile" replace />;
  }

  // Jeśli wymagane są uprawnienia admina (admin lub super admin)
  if (adminOnly && user?.role !== 'admin' && user?.role !== 'super admin') {
    return <Navigate to="/profile" replace />;
  }

  // Jeśli wymagany jest dostęp do modułu (pojedynczy lub wiele)
  if (moduleAccessAny && Array.isArray(moduleAccessAny)) {
    // Super admin zawsze ma dostęp do wszystkich modułów (może nadawać uprawnienia)
    if (user?.role === 'super admin') {
      return children;
    }
    // Admin NIE ma automatycznego dostępu - musi mieć nadane uprawnienie przez super admina
    // Sprawdź czy użytkownik ma dostęp do któregoś z modułów (OR logic)
    const hasAccess = moduleAccessAny.some(module => user?.moduleAccess?.[module]);
    if (!hasAccess) {
      return <Navigate to="/profile" replace />;
    }
    // kadryHROnly w trybie OR też ma egzekwować ograniczenie do HR
    if (kadryHROnly && user?.role !== 'super admin' && user?.department !== 'HR') {
      return <Navigate to="/kadry/wnioski" replace />;
    }
  } else if (moduleAccess) {
    // Super admin zawsze ma dostęp do wszystkich modułów (może nadawać uprawnienia)
    if (user?.role === 'super admin') {
      return children;
    }
    // Kadry HR only - Pracownicy tylko dla działu HR lub super admina
    if (kadryHROnly && user?.role !== 'super admin' && user?.department !== 'HR') {
      return <Navigate to="/kadry/wnioski" replace />;
    }
    // Sprawdź czy użytkownik ma dostęp do modułu
    if (!user?.moduleAccess?.[moduleAccess]) {
      return <Navigate to="/profile" replace />;
    }
  }

  return children;
};

export default ProtectedRoute;
